import lottie from 'lottie-web'
import { memo, useEffect, useRef, useState } from 'react'
import { useCountUp } from 'use-count-up'
import SendingMailLottieFile from '~assets/animations/sending-mail.json'

type ConsultationSubmittingProps = Readonly<{
  progress: number
}>

const ConsultationSubmitting = ({ progress }: ConsultationSubmittingProps) => {
  const sendingMailLottieRef = useRef<HTMLDivElement>(null)
  const [dummyProgressStart, setDummyProgressStart] = useState(0)
  const [dummyProgressEnd, setDummyProgressEnd] = useState(99)
  const { value } = useCountUp({
    start: dummyProgressStart,
    end: dummyProgressEnd,
    duration: 7,
    easing: 'easeOutCubic',
    isCounting: dummyProgressEnd < 100 && progress >= 0,
    onComplete: () => {
      setDummyProgressEnd(100)
    },
  })

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: sendingMailLottieRef.current as Element,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: SendingMailLottieFile,
    })

    return () => instance.destroy()
  }, [])

  useEffect(() => {
    setDummyProgressStart(progress ?? 0)
    setDummyProgressEnd(prev => Math.max(progress, prev))
  }, [progress])

  return (
    <div className="mb-10 flex flex-col items-center px-5 w-full h-full justify-center">
      <div ref={sendingMailLottieRef} className="-my-16 h-52 w-full" />
      <div className="my-4 text-gray-500 text-body-1">{value}%</div>
      <div className="mb-4 text-primary-600 text-headline-3 dark:text-white">
        Delivering your question
      </div>
      <p className="whitespace-pre-line break-words text-center text-primary-600 text-body-2 lg:text-body-3 dark:text-gray-500">
        {`Give us a second.\nYour questions are safely stored and being delivered to Dr.Tail Vet.`}
      </p>
    </div>
  )
}

export default memo(ConsultationSubmitting)
